module.exports = __webpack_public_path__ + "static/img/pa.7b97403f.svg";